import { useContext } from 'react';

import { CookieConsentContext } from '../../../../contexts';
import { Box, Flex } from '../../../atoms';
import { CookieConsentProps } from '../types';
import { ConsentButton } from '../styles';
import { AcceptButton, ManageLink, SimplifiedContainer, Subtitle, Title } from './styles';

interface SimplifiedCookieConsentProps extends CookieConsentProps {
  onShowFull: () => void;
}

export const SimplifiedCookieConsent = ({ onShowFull, ...props }: SimplifiedCookieConsentProps) => {
  const consent = useContext(CookieConsentContext);

  const handleAccept = () => {
    const allEnabled = {
      necessary: true,
      statistics: true,
    };
    consent.selectCookieSections(allEnabled);
  };

  return (
    <SimplifiedContainer {...props}>
      <Flex justifyContent="space-between" alignItems="flex-start">
        <Box flex="1" mr={3}>
          <Title>This site uses cookies</Title>
          <Subtitle>
            Manage your privacy choices <ManageLink onClick={onShowFull}>here</ManageLink>
          </Subtitle>
        </Box>
      </Flex>
      <AcceptButton as={ConsentButton} onClick={handleAccept}>
        Accept
      </AcceptButton>
    </SimplifiedContainer>
  );
};
